import { render, staticRenderFns } from "./brandLadder.vue?vue&type=template&id=96cb8e94&scoped=true&"
import script from "./brandLadder.vue?vue&type=script&lang=js&"
export * from "./brandLadder.vue?vue&type=script&lang=js&"
import style0 from "./brandLadder.vue?vue&type=style&index=0&id=96cb8e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb8e94",
  null
  
)

export default component.exports